import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export const ORG_APP_SUBSCRIPTIONS_LOOKUP_RESOURCE = 'orgAppSubscriptionsLookup';

const orgAppSubscriptionsLookupService = ComposedComponent =>
  reduxFetch([
    {
      resource: ORG_APP_SUBSCRIPTIONS_LOOKUP_RESOURCE,
      method: 'get',
      request: (organisationId, installationId) => ({
        url: addParametersToUri(apiRoutes.organisationApps(), {
          organisationId,
          appInstallationId: installationId,
        }),
        clearValueOnRequest: true,
      }),
    },
  ])(ComposedComponent);

export default orgAppSubscriptionsLookupService;
